import React from 'react';
import {Progress, Button, Modal, ModalHeader, ModalFooter, ModalBody,Dropdown,DropdownMenu , DropdownToggle,DropdownItem,Form,FormGroup, FormText,Label, Input  } from 'reactstrap';
import $ from 'jquery';
import ValidatedTextBox from '../ValidatedTextBox'
import ValidatedDropDown from '../ValidatedDropDown'
import { connect } from 'react-redux'

class FileDropSelectionModal extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        docTypedropdownOpen: false,
        dropDownValue : "",
        dropDownText : "Document Type",
        dropDownData : {},
        documentTypes: [],
        metaFields : [],
        needControls : true
      };
    }

    componentDidUpdate(prevProps) {
      if(this.props.fileName !== prevProps.fileName)
        this.getDocumentTypes();
    }

    componentDidMount() {
      this.getDocumentTypes();
    }

    getDocumentTypes = () => {
       //load the available document types
       fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentTypes?SystemDefined=false')
       .then(res => res.json())
       .then(result => {
         //loop the returned values and push them to a local state object
         this.setState({ documentTypes: result  });
       }) //should return an array of document types
       .catch(error=>
       {
         //need to log the error
         console.error(error);
       });
    }

    genericDropDownChange = (e) => {
      this.setState({
        dropDownValue: e.currentTarget.id , 
        dropDownText : e.currentTarget.textContent , 
        documentTypeConfig : this.state.documentTypes[e.currentTarget.id]
      });      

    }

    attemptSave = () => 
    {

      var metaData = 
      {
        CabinetType:"X3",
        CabinetId:1,
        PortfolioType:"",
        PortfolioId: {},
        DocumentType : this.state.documentTypeConfig.DocumentType,
        DocumentID : this.state.DocumentRef,
        Version: "1",
        DateTimeCreated: Date.now(),
        ImportType: "Manual",
        UserName : this.props.userReducer.user, //todo - this needs to be sorted during security
        Status : "Active",
        Pages : 1,
        Language : "BRI", //todo - this needs to be sorted during security 
        ActionData: {},
        DocumentData: {},
        FileId : {},
        AttachmentLocation : this.props.fileName
      };

      var data = new FormData();

      //apend the file and then the meta data as seperate parms
      data.append("document", this.props.fileData);
      data.append("metaData", JSON.stringify(metaData));
      data.append("parentType",this.props.parentType);
      data.append("parentRef",this.props.parentRef);

      fetch(window.location.protocol + '//' + window.location.host + "/api/archive/documents",
      {
        method: "POST",
        body: data
      })
      .then(() => { 
        this.setState({allowSave:''});
        this.props.toggleAddModal();
      })
      .catch((error) => {  
        //display an error 
        //TODO: how??
        this.setState({allowSave:''});
        this.props.toggleAddModal();
      });
    }

    render() 
    {      
        return <Modal isOpen={this.props.visible} toggle={this.props.toggleAddModal} className='modal-dialog'>
          <ModalHeader toggle={this.props.toggleAddModal}>Select Document Type</ModalHeader>
            <ModalBody>
                <Form>
                    <ValidatedTextBox id="DocumentRef" labelText="Document Ref" onChange={(b,e) => this.setState({DocumentRef: e.target.value})} value={this.props.parentRef} />
                    <ValidatedDropDown id="DocumentType" labelText="Document Type" onChange={this.genericDropDownChange} mandatory={true} documentTypes={this.state.documentTypes}/>
                </Form>
            </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.attemptSave}>Save</Button>
          </ModalFooter>
        </Modal>
    }
    
}

export default connect(state => state)(FileDropSelectionModal); 
